import { z } from "zod";

/**
 * Use this if you need to loop through all the options
 */
export const ThemeValues = [
  "LIGHT",
  "DARK",
  "BARBIE",
  "CATPPUCCIN",
  "EVERFOREST",
  "EVERFORESTMEDIUM",
  "EVERFORESTSOFT",
  "TOKYONIGHT",
  "HOTPINK",
  "NORD",
  "NORDLITE",
  "SUNDAYMORNING",
  "VSCODEDARK",
] as const;
/**
 * Use this if you need to zod parse it
 */
export const ThemeSchema = z.enum(ThemeValues);
/**
 * Use this if you need to use the literal value
 */
export const Theme = ThemeSchema.enum;
/**
 * Use this if you need to use the type
 */
export type Theme = z.infer<typeof ThemeSchema>;
/**
 * Use this if you need to display a human-readable name
 */
export const ThemeDisplayNames: Record<Theme, string> = {
  LIGHT: "Light",
  DARK: "Dark",
  BARBIE: "Barbie",
  CATPPUCCIN: "Catppuccin",
  EVERFOREST: "Everforest (Hard)",
  EVERFORESTMEDIUM: "Everforest (Medium)",
  EVERFORESTSOFT: "Everforest (Soft)",
  TOKYONIGHT: "Tokyo Night",
  HOTPINK: "Hot Pink",
  NORD: "Nord",
  NORDLITE: "Nord Lite",
  SUNDAYMORNING: "Sunday Morning",
  VSCODEDARK: "VSCode Dark",
} as const;

export const ThemeIsDark = {
  LIGHT: false,
  DARK: true,
  BARBIE: false,
  CATPPUCCIN: true,
  EVERFOREST: true,
  EVERFORESTMEDIUM: true,
  EVERFORESTSOFT: true,
  TOKYONIGHT: true,
  HOTPINK: false,
  NORD: true,
  NORDLITE: false,
  SUNDAYMORNING: false,
  VSCODEDARK: true,
} as const satisfies Record<Theme, boolean>;

export const ThemePreferenceValues = [...ThemeValues, "SYSTEM"] as const;
export const ThemePreferenceSchema = z.enum(ThemePreferenceValues);
export const ThemePreference = ThemePreferenceSchema.enum;
export type ThemePreference = z.infer<typeof ThemePreferenceSchema>;

export const ThemePreferenceDisplayNames: Record<ThemePreference, string> = {
  ...ThemeDisplayNames,
  SYSTEM: "System",
} as const;

// SYSTEM must never reach the DOM or `theme === Theme.X` consumers.
export const resolveThemePreference = (preference: ThemePreference, prefersDark: boolean): Theme => {
  if (preference !== ThemePreference.SYSTEM) {
    return preference;
  }
  return prefersDark ? Theme.DARK : Theme.LIGHT;
};
